import React from "react";
import { Translate } from "components/common/Translate/Translate";
import dynamic from "next/dynamic";

const WebpResizeDimensionsImagePreview = dynamic<{image?: string}>(
    () => import("@/components/features/WebpResizer/WebpResizeFlexibleSettingsImagePreview").then((mod) => mod),
    {
        ssr: false,
    },
);

const WebpUnlockAspectRatioImagePreview = dynamic<{image?: string}>(
    () => import("@/components/features/WebpResizer/WebpUnlockAspectRatioImagePreview").then((mod) => mod),
    {
        ssr: false,
    },
);

export const WebpResizeByDimensions = ({image}: {image?:string}) => {
    return (
        <>
            <div className="flex flex-col md:flex-row items-center mt-20">
                <div className="flex-1 gap-2 hidden md:block">
                    <WebpResizeDimensionsImagePreview image={image} />
                </div>
                <div className="flex-1 dark:text-white text-center md:text-left">
                    <h2 className="text-24 font-semibold">
                        <Translate keyName="Flexible-Resize-Settings-title" />
                    </h2>
                    <p className="md:pt-6">
                        <Translate keyName="Flexible-Resize-Settings-subtitle" />
                    </p>
                </div>
                <div className="flex-1 gap-2  md:hidden">
                <WebpResizeDimensionsImagePreview image={image} />
            </div>
            </div>

            <div className="flex flex-col md:flex-row items-center mt-20">
                <div className="flex-1 dark:text-white text-center md:text-left order-2 md:order-1">
                    <h2 className="text-24 font-semibold">
                        <Translate keyName="Unlock-Aspect-Ratio-title" />
                    </h2>
                    <p className="md:pt-6">
                        <Translate keyName="Unlock-Aspect-Ratio-subtitle" />
                    </p>
                </div>
                <div className="flex-1 gap-2 hidden md:block order-1 md:order-2">
                    <WebpUnlockAspectRatioImagePreview image={image} />
                </div>
            </div>
            <div className="flex-1 gap-2  md:hidden">
                <WebpUnlockAspectRatioImagePreview image={image} />
            </div>
        </>
    )
};

